
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.58705 11.4654C6.84128 11.312 7.15959 11.312 7.41383 11.4654L10.3212 13.2202C10.9271 13.5859 11.6745 13.0427 11.5137 12.3536L10.7421 9.04617C10.6747 8.75698 10.773 8.45421 10.9974 8.25976L13.5673 6.03344C14.1022 5.57007 13.8163 4.69146 13.1111 4.63164L9.72913 4.34471C9.43347 4.31962 9.17598 4.13296 9.06019 3.85976L7.73701 0.737817C7.46134 0.0873936 6.53953 0.0873947 6.26386 0.737818L4.94069 3.85976C4.8249 4.13296 4.56741 4.31962 4.27174 4.34471L0.889735 4.63164C0.184593 4.69146 -0.101334 5.57007 0.433545 6.03344L3.00347 8.25976C3.22792 8.45421 3.3262 8.75698 3.25873 9.04618L2.48716 12.3536C2.32639 13.0427 3.07378 13.5859 3.67963 13.2202L6.58705 11.4654Z"}})])
          )
        }
      }
    